import { EXTEND, IS, nil, NO, UIRoute, UIView, UIViewController, YES } from "uicore-ts"
import { RHColor } from "../Custom components/RH/RHColor"
import { PublishedProcurementsViewController } from "../OngoingProcurements/PublishedProcurementsViewController"
import { UserMainViewController } from "./UserMainViewController"


/**
 * The offerer workspace hosts one searchable procurement list. Personal
 * relevance and invitations are facets of that list instead of separate pages.
 */
export class OffererMainViewController extends UIViewController {

    static override readonly routeComponentName = "offerer_main"
    static override readonly ParameterIdentifierName = {}

    readonly contentPanelView = new UIView().addedAsSubviewToView(this.view).configuredWithObject({
        layoutSubviews: EXTEND(() => {
            const childView = this.contentPanelView.subviews.firstElement
            if (IS(childView)) {
                childView.frame =
                    this.contentPanelView.contentBoundsWithInset(0)
                        .rectangleWithHeight(childView)
            }
        })
    })

    readonly publishedProcurementsViewController = new PublishedProcurementsViewController(
        new UIView("OffererMainPublishedProcurementsView"),
        { showsExposureFilters: YES }
    )


    constructor(view: UIView) {
        super(view)
        this.view.configureWithObject({
            backgroundColor: RHColor.background
        })
        this.publishedProcurementsViewController.configureWithObject({
            backToRouteComponentName: UserMainViewController.routeComponentName,
            showsPageTitle: NO
        })
    }


    override async handleRoute(route: UIRoute) {
        await this._mountPublishedProcurementsViewControllerIfNeeded()
        await super.handleRoute(route)
    }


    async _mountPublishedProcurementsViewControllerIfNeeded() {
        if (!this.hasChildViewController(this.publishedProcurementsViewController)) {
            this.addChildViewControllerInContainer(
                this.publishedProcurementsViewController,
                this.contentPanelView
            )
            await this.publishedProcurementsViewController.viewWillAppear()
            this.publishedProcurementsViewController.viewDidAppear().then(nil)
        }
        this.view.setNeedsLayoutUpToRootView()
    }


    override layoutViewSubviews() {
        super.layoutViewSubviews()

        const padding = this.core.paddingLength
        const bounds = this.view.contentBoundsWithInset(padding)

        bounds
            .rectangleWithHeight(this.contentPanelView)
            .assignedAsFrameOfView(this.contentPanelView)
    }

}
